
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UnlockAnswersIconComponent } from "./unlock-answers-icon.svg";

export const UnlockAnswersIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UnlockAnswersIconComponent {...props} />;
};
